/* eslint-disable react/no-array-index-key */
import { StyleSheet, View, Text } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  tableStyle: {
    width: 'auto',
  },
  tableRowStyle: {
    flexDirection: 'row',
  },
  tableCellHeaderStyle: {
    textAlign: 'left',
    margin: 4,
    fontSize: 8,
    fontWeight: 'bold',
  },
  tableCellStyle: {
    textAlign: 'left',
    margin: 5,
    fontSize: 8,
  },
});

interface TableProps {
  headers: Array<{ size: string; text: string }>;
  rows: Array<Array<string | number | null>>;
}

export const TableHeader = ({ headers }: { headers: TableProps['headers'] }) => (
  <View style={styles.tableRowStyle} fixed>
    {headers.map((header) => (
      <View style={{ width: header.size }} key={header.text}>
        <Text style={styles.tableCellHeaderStyle}>{header.text}</Text>
      </View>
    ))}
  </View>
);

export const TableRow = ({
  data,
  headers,
}: {
  data: Array<string | number | null>;
  headers: TableProps['headers'];
}) => (
  <View style={styles.tableRowStyle}>
    {data.map((item, index) => (
      <View key={`column-${index}`} style={{ width: headers[index].size }}>
        <Text style={styles.tableCellStyle}>{item || 'N/A'}</Text>
      </View>
    ))}
  </View>
);

const Table = ({ headers, rows }: TableProps) => (
  <View style={styles.tableStyle}>
    <TableHeader headers={headers} />

    {rows.map((row, index) => (
      <TableRow data={row} headers={headers} key={`row-${index}`} />
    ))}
  </View>
);

export default Table;
